import {
  CartItem,
  CartItemBase,
  CartItemTypeEnum,
} from '@sola/schema/dotcom/cart/cart-item.js';
import { CartItemFund } from '@sola/schema/dotcom/cart/fund.js';
import {
  CartItemGift,
  CartItemGiftBirthday,
  CartItemGiftCenter,
  CartItemGiftChild,
  CartItemGiftFamily,
  GiftTypeEnum,
} from '@sola/schema/dotcom/cart/gift.js';
import { CartItemPayment } from '@sola/schema/dotcom/cart/payment.js';
import {
  CartItemSponsorship,
  CartItemSponsorshipChildCriteria,
  CartItemSponsorshipEPayment,
  CartItemSponsorshipFirstPayment,
  CartItemSponsorshipLongestWaiting,
  CartItemSponsorshipSelected,
  SponsorshipItemTypeEnum,
} from '@sola/schema/dotcom/cart/sponsorship.js';

type ItemFund = CartItemBase & CartItemFund;
type ItemGift = CartItemBase & CartItemGift;
type ItemGiftBirthday = ItemGift & /* CartItemGift & */ {
  gift: CartItemGiftBirthday;
};
type ItemGiftChild = CartItem & /* CartItemGift & */ {
  gift: CartItemGiftChild;
};
type ItemGiftFamily = CartItem & /* CartItemGift & */ {
  gift: CartItemGiftFamily;
};
type ItemGiftCenter = CartItem & /* CartItemGift & */ {
  gift: CartItemGiftCenter;
};
type ItemPayment = CartItem & CartItemPayment;
type ItemSponsorship = CartItemBase & CartItemSponsorship;
type ItemSponsorshipSelected = CartItem & /* CartItemSponsorship & */ {
  sponsorship: CartItemSponsorshipSelected;
};
type ItemSponsorshipFirstPayment = CartItem & /* CartItemSponsorship & */ {
  sponsorship: CartItemSponsorshipFirstPayment;
};
type ItemSponsorshipEPayment = CartItem & /* CartItemSponsorship & */ {
  sponsorship: CartItemSponsorshipEPayment;
};
type ItemSponsorshipLongestWaiting = CartItem & /* CartItemSponsorship & */ {
  sponsorship: CartItemSponsorshipLongestWaiting;
};
type ItemSponsorshipCriteria = CartItem & /* CartItemSponsorship & */ {
  sponsorship: CartItemSponsorshipChildCriteria;
};

/**
 * Funds
 */
export const isItemFund = (item: CartItem): item is ItemFund =>
  item.itemType === CartItemTypeEnum.Fund;

/**
 * Gifts
 */
export const isItemGift = (item: CartItem | CartItemGift): item is ItemGift =>
  item.itemType === CartItemTypeEnum.Gift;

export const isItemGiftBirthday = (item: CartItem): item is ItemGiftBirthday =>
  isItemGift(item) && item.gift.giftType === GiftTypeEnum.Birthday;

export const isItemGiftChild = (item: CartItem): item is ItemGiftChild =>
  isItemGift(item) && item.gift.giftType === GiftTypeEnum.Child;

export const isItemGiftFamily = (item: CartItem): item is ItemGiftFamily =>
  isItemGift(item) && item.gift.giftType === GiftTypeEnum.Family;

export const isItemGiftCenter = (
  item: CartItem | CartItemGift,
): item is ItemGiftCenter =>
  isItemGift(item) && item.gift.giftType === GiftTypeEnum.Center;

/**
 * Payments
 */
export const isItemPayment = (item: CartItem): item is ItemPayment =>
  item.itemType === CartItemTypeEnum.Payment;

/**
 * Sponsorships
 */
export const isItemSponsorship = (item: CartItem): item is ItemSponsorship =>
  item.itemType === CartItemTypeEnum.Sponsorship;

export const isItemSponsorshipSelected = (
  item: CartItem,
): item is ItemSponsorshipSelected =>
  isItemSponsorship(item) &&
  item.sponsorship.sponsorshipType === SponsorshipItemTypeEnum.Selected;

export const isItemSponsorshipFirstPayment = (
  item: CartItem,
): item is ItemSponsorshipFirstPayment =>
  isItemSponsorship(item) &&
  item.sponsorship.sponsorshipType === SponsorshipItemTypeEnum.FirstPayment;

export const isItemSponsorshipEPayment = (
  item: CartItem,
): item is ItemSponsorshipEPayment =>
  isItemSponsorship(item) &&
  item.sponsorship.sponsorshipType === SponsorshipItemTypeEnum.EPayment;

export const isItemSponsorshipLongestWaiting = (
  item: CartItem,
): item is ItemSponsorshipLongestWaiting =>
  isItemSponsorship(item) &&
  item.sponsorship.sponsorshipType === SponsorshipItemTypeEnum.LongestWaiting;

export const isItemSponsorshipCriteria = (
  item: CartItem,
): item is ItemSponsorshipCriteria =>
  isItemSponsorship(item) &&
  item.sponsorship.sponsorshipType === SponsorshipItemTypeEnum.ChildCriteria;

/** Is there a helpful way to group these together? */
// export const fundTypeGuards = {
//   isFundItem,
//   isGiftItem,
//   isGiftBirthday,
//   isGiftChild,
//   isGiftFamily,
//   isGiftCenter,
// };
//
// export const sponsorshipTypeGuards = {
//   isSponsorshipItem,
//   isSponsorshipSelected,
//   isSponsorshipFirstPayment,
//   isSponsorshipEPayment,
//   isSponsorshipLongestWaiting,
//   isSponsorshipCriteria,
// };

/** or maybe: */
// export const cartItemTypGuards = {
//   fund: {
//     isFundItem,
//   },
//   gift: {
//     isGiftItem,
//     isGiftBirthday,
//     isGiftChild,
//     isGiftFamily,
//     isGiftCenter,
//   },
//   payment: {
//     isPaymentItem,
//   },
//   sponsorship: {
//     isSponsorshipItem,
//     isSponsorshipSelected,
//     isSponsorshipFirstPayment,
//     isSponsorshipEPayment,
//     isSponsorshipLongestWaiting,
//     isSponsorshipCriteria,
//   },
// };
